import { Dayjs } from 'dayjs';
import dayjs from './dayjsSetup';

const isEndOfMonth = (date: Dayjs): boolean => {
  return dayjs(date).isSame(dayjs(date).endOf('month'), 'day');
};

export default isEndOfMonth;
